export const template_pekerjaan = {
  router: [
    {
      name: "TEMPLATE PEKERJAAN",
      key: "template_pekerjaan",
      path: "/admin/master/template-pekerjaan",
      apiUrl: {
        data: "master/api/template/pekerjaan/",
        preview: "master/api/template/pekerjaan/",
      },
      breadCrumb: [
        {
          label: "MASTER",
          link: "#",
          active: false,
        },
        {
          label: "TEMPLATE PEKERJAAN",
          link: "#",
          active: true,
        },
      ],
      component: "datatable1",
    },
  ],
  model: [
    {
      name: "id",
      isPk: true,
      isForm: false,
      isTable: false,
    },
    {
      name: "nama",
      label: "Nama",
      type: "text",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
  ],
};
